var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "row" },
      [
        _vm._m(0),
        _vm._v(" "),
        !_vm.namespaces ? _c("loader") : _vm._e(),
        _vm._v(" "),
        _vm.namespaces && _vm.namespaces.length > 0
          ? _c(
              "div",
              {
                staticClass: "form-group",
                on: {
                  click: function($event) {
                    _vm.createNewNamespace = false
                  }
                }
              },
              [
                _c("div", { staticClass: "custom-control custom-radio" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.createNewNamespace,
                        expression: "createNewNamespace"
                      }
                    ],
                    staticClass: "custom-control-input",
                    attrs: {
                      type: "radio",
                      value: "false",
                      name: "radio-stacked",
                      required: ""
                    },
                    domProps: {
                      checked: _vm._q(_vm.createNewNamespace, "false")
                    },
                    on: {
                      focus: function($event) {
                        _vm.createNewNamespace = false
                      },
                      change: function($event) {
                        _vm.createNewNamespace = "false"
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { staticClass: "custom-control-label" }, [
                    _vm._v("Select an exising namespace:")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.existingNamespace,
                        expression: "existingNamespace"
                      }
                    ],
                    on: {
                      focus: function($event) {
                        _vm.createNewNamespace = false
                      },
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.existingNamespace = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  _vm._l(_vm.namespaces, function(n) {
                    return _c(
                      "option",
                      { key: n.namespace, domProps: { value: n.namespace } },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" + _vm._s(n.namespace) + "\n\t\t\t\t"
                        )
                      ]
                    )
                  }),
                  0
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.namespaces
          ? _c(
              "div",
              {
                staticClass: "form-group",
                on: {
                  click: function($event) {
                    _vm.createNewNamespace = true
                  }
                }
              },
              [
                _c("div", { staticClass: "custom-control custom-radio" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.createNewNamespace,
                        expression: "createNewNamespace"
                      }
                    ],
                    staticClass: "custom-control-input",
                    attrs: {
                      type: "radio",
                      value: "true",
                      name: "radio-stacked",
                      required: ""
                    },
                    domProps: {
                      checked: _vm._q(_vm.createNewNamespace, "true")
                    },
                    on: {
                      focus: function($event) {
                        _vm.createNewNamespace = true
                      },
                      change: function($event) {
                        _vm.createNewNamespace = "true"
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { staticClass: "custom-control-label" }, [
                    _vm._v("Create a new namespace:")
                  ])
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newNamespace,
                      expression: "newNamespace"
                    }
                  ],
                  staticClass: "form-control tests_namespace_name_input",
                  attrs: { placeholder: "" },
                  domProps: { value: _vm.newNamespace },
                  on: {
                    focus: function($event) {
                      _vm.createNewNamespace = true
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.newNamespace = $event.target.value
                    }
                  }
                })
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showExpiration && _vm.namespaces
          ? _c("div", { staticClass: "row" }, [
              _c("label", { staticClass: "custom-control-label" }, [
                _vm._v("Expires in")
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.expiration,
                      expression: "expiration"
                    }
                  ],
                  staticClass: "expiration-select",
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.expiration = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                _vm._l(_vm.expirationOptions, function(o) {
                  return _c(
                    "option",
                    { key: o.expiration, domProps: { value: o.expiration } },
                    [_vm._v("\n\t\t\t\t\t" + _vm._s(o.label) + "\n\t\t\t\t")]
                  )
                }),
                0
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        !(_vm.showTokenGeneration == "false")
          ? _c(
              "button",
              {
                staticClass: "btn btn-primary tests_create_token_action",
                attrs: { id: "gen-token-btn", type: "button" },
                on: {
                  click: function($event) {
                    return _vm.generateToken()
                  }
                }
              },
              [_vm._v("Generate Access Token")]
            )
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _vm.namespaces && _vm.token
      ? _c("div", { staticClass: "row" }, [
          _c("label", [_vm._v("Access Token:")]),
          _vm._v(" "),
          _c("div", { staticClass: "token-group" }, [
            _c("input", {
              ref: "tokenref",
              staticClass: "form-control tests_token_value_input",
              attrs: { type: "text", placeholder: "" },
              domProps: { value: _vm.token },
              on: { click: _vm.onClickToken }
            })
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "alert alert-warning", attrs: { role: "alert" } },
      [
        _c("i", { staticClass: "fa fa-exclamation fa-fw" }),
        _vm._v(
          "\n\t\t\tAny application with that token will have full access to the selected namespace.\n\t\t"
        )
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e742a4ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e742a4ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CreateToken.vue
// module id = null
// module chunks = 